import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';

import styles from './GoogleButton.module.scss';

export const GoogleButton = ({ onLoginSuccess = () => {}, onLoginFailure = () => {} }) => {
  return (
    <div className={styles.root}>
      <GoogleOAuthProvider clientId="31598861663-kakuv7trragnqicvd2m2c6qo821n3694.apps.googleusercontent.com">
        <GoogleLogin
          width="380"
          text="continue_with"
          height="50"
          theme="outline"
          size="large"
          onSuccess={onLoginSuccess}
          onError={onLoginFailure}
        />
      </GoogleOAuthProvider>
    </div>
  );
};
